var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3258 4.16032L13.1711 7.00564M10.3258 4.16032L4.319 10.1671C3.90858 10.5775 3.64234 11.11 3.56025 11.6846L3.33895 13.2337C3.27572 13.6763 3.6551 14.0557 4.0977 13.9925L5.64682 13.7712C6.22142 13.6891 6.7539 13.4229 7.16432 13.0124L13.1711 7.00564M10.3258 4.16032L11.0725 3.41361C11.8535 2.63256 13.1283 2.64101 13.9094 3.42206C14.6904 4.20311 14.6989 5.47788 13.9178 6.25893L13.1711 7.00564",
    stroke: "#ACABAB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.14786 3.64609C2.96096 3.22778 2.36717 3.22778 2.18026 3.64609L1.80891 4.47721L0.977792 4.84856C0.559486 5.03546 0.559486 5.62925 0.977792 5.81616L1.80891 6.18751L2.18026 7.01863C2.36717 7.43693 2.96096 7.43693 3.14786 7.01863L3.51921 6.18751L4.35033 5.81616C4.76864 5.62925 4.76864 5.03546 4.35033 4.84856L3.51921 4.47721L3.14786 3.64609Z",
    fill: "#4200FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31993 2.20818C6.19533 1.92931 5.79947 1.92931 5.67486 2.20818L5.4273 2.76226L4.87322 3.00982C4.59434 3.13443 4.59434 3.53029 4.87322 3.65489L5.4273 3.90246L5.67486 4.45654C5.79947 4.73541 6.19533 4.73541 6.31993 4.45654L6.5675 3.90246L7.12158 3.65489C7.40045 3.53029 7.40045 3.13443 7.12158 3.00982L6.5675 2.76226L6.31993 2.20818Z",
    fill: "#4200FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencilIcon.4999ffe77dc2e4a87a6db7dc688e7dbc.svg";
export { ForwardRef as ReactComponent };